// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3otd2","validationTips":"StatementDescriptor_validationTips__-E9_C"};